import React, { createContext, useState } from 'react'
import PropTypes from 'prop-types'

export const AuthorizeContext = createContext({
    isOpen: false,
    isRedirectLk: false,
    toggleIsOpen: (isRedirectLk) => {}
})

// eslint-disable-next-line react/prop-types
const AuthorizeState = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [currentIsRedirect, setCurrentIsRedirect] = useState(false)
    const toggleIsOpenHandler = (isRedirectLk = false) => {
        setIsOpen(!isOpen)
        setCurrentIsRedirect(isRedirectLk)
    }

    return (
        <AuthorizeContext.Provider
            value={{
                isOpen,
                isRedirectLk: currentIsRedirect,
                toggleIsOpen: toggleIsOpenHandler
            }}>
            {children}
        </AuthorizeContext.Provider>
    )
}

AuthorizeState.propTypes = {
    children: PropTypes.node.isRequired
}

export default AuthorizeState
